import posts from "./blog.generated.json";

export type BlogSource = {
  title: string;
  url: string;
};

export type BlogSection = {
  heading: string;
  body: string[];
};

export type BlogPost = {
  slug: string;
  title: string;
  description: string;
  keyword: string;
  audience: string;
  readTime: string;
  published: string;
  sections: BlogSection[];
  sources: BlogSource[];
};

export const blogPosts = posts as BlogPost[];
